module.exports = __webpack_public_path__ + "img/about-img_2-min.7dfd8147.jpg";